import { network } from 'services/network';
import { useQuery } from 'react-query';

const getTopDurations = (params) => {
    return network
        .post('api/bo/getTopDurationOverrunRisk', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};
const useQueryTopDurations = (params) => {
    return useQuery(['topDurations', params], () => getTopDurations(params), {
        enabled: params.id.length > 0,
    });
};
export { useQueryTopDurations };
